<div class="flex text-navy-90 font-bold text-base">
  {{ buildTranslationKey('header') | translate }}

  <svg-icon
    class="w-3.5 ml-1"
    [src]="'info-dark'"
    [ngbTooltip]="buildTranslationKey('tooltip') | translate"
    [tooltipClass]="'default-tooltip access-limitation-tooltip'"
    [placement]="'top'"
  ></svg-icon>
</div>

<div
  class="toggle-container flex items-center gap-x-3 cursor-pointer w-fit"
  role="button"
  (click)="updateTimeLimitationFlag(!hasAccessTimeLimitation)">
  <app-toggle
    class="toggle"
    [ngModel]="hasAccessTimeLimitation"
    (ngModelChange)="updateTimeLimitationFlag($event)">
  </app-toggle>

  <span class="text-navy-70 text-base">{{ buildTranslationKey('label') | translate }}</span>
</div>

<app-dropdown-control
  class="max-w-63.5"
  [selectedValue]="selectedTimeLimit"
  [data]="timeLimitationOptions"
  [disableRepeatSelectionEvent]="true"
  [idSelector]="idLimitationsSelector"
  [displayValueSelector]="displayLimitationsSelector"
  [isDisabled]="!hasAccessTimeLimitation"
  (selectClick)="updateTimeLimitation($event)"
></app-dropdown-control>
